import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import axios from 'axios';
import moment from 'moment';
import momentDe from 'moment/locale/de';
import colors from 'vuetify/es5/util/colors';
import { ResizeObserver } from 'vue-resize';
import App from './App.vue';
import router from './router';
import store from './store/index';
import auth from './services/auth';
import 'vuetify/src/stylus/app.styl';
// import './services/registerServiceWorker';
import './ui/_style/application.scss';
import 'vue-resize/dist/vue-resize.css';

moment.locale('de', momentDe);
Vue.config.productionTip = false;

axios.interceptors.request.use(auth.requestInterceptor);
axios.interceptors.response.use(x => x, auth.responseErrorInterceptor);

Vue.prototype.$http = axios;
Vue.prototype.$variables = store.variables.state;
Vue.prototype.$moment = moment;

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: colors.blue.accent3,
    secondary: colors.blue.lighten1,
    accent: colors.shades.white,
  },
});
Vue.component('resize-observer', ResizeObserver);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
